import { Controller } from "@hotwired/stimulus";
import consumer from "../channels/consumer";

export default class extends Controller {
  connect() {
    this.subscription = consumer.subscriptions.create(
      {
        channel: this.data.get("channel")
      },
      {
        received: this.received.bind(this)
      }
    );
  }

  received() {
    if (!!this.data.get("refresh")) {
      Turbo.visit(window.location.href);
    } else {
      fetch(location.toString())
        .then(response => response.text())
        .then(html => {
          const newDocument = new DOMParser().parseFromString(html, "text/html");
          const selector = `[data-socket-replace-channel=${this.data.get("channel")}]`;

          document.querySelector(selector).innerHTML = newDocument.querySelector(
            selector
          ).innerHTML;
        });
    }
  }

  disconnect() {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }
}
